import * as _ from "lodash";
import {BaseInternalView, BaseInternalViewOptions} from "../views/_BaseViews";
import {AppCollection} from "../collections/Apps";
import {BaseApp} from "./_BaseApp";

/* The basic view for any app */
export interface BaseAppViewOptions extends BaseInternalViewOptions{
    appCollection: AppCollection;
    appController?: BaseApp;
}
export class BaseAppView extends BaseInternalView {

    public options: BaseAppViewOptions;

    constructor(options: BaseAppViewOptions){
        super(options);
    }

    remove() {
        // Remove listeners from the global event bus
        this.stopListening();

        return super.remove();
    }

}

/* A simple view that shows the error message "App not enabled" */
export class AppNotEnabledView extends BaseAppView {

    private template = _.template(require('./shared/templates/appNotEnabled.html'));

    render() {
        this.$el.html(this.template({}));
        return this
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/apps/_BaseAppViews.ts